<div class="card cardMeasurements" data-testid="order-group-card">
  <div class="card-body">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h5 class="card-title mb-1 d-block">
          <span i18n>Bestellung vom {{ orderGroup()?.orderGroupDateTime | date }}</span>
          @if (statusLabel) {
            <span class="badge ms-2" [ngClass]="statusBadgeClass">{{ statusLabel }}</span>
          }
        </h5>
      </div>
      <div class="col-sm-4"></div>
      <div class="col-sm-2">
        <div>
          <button
            class="btn btn-sm btn-outline-secondary"
            type="button"
            data-testid="order-group-details-button"
            (click)="onEditOrderGroup()"
            i18n
            >
            Bestelldetails
          </button>
        </div>
      </div>

    </div>

    @for (order of orderGroup().orders; track order.id) {
      <app-order-group-order-item data-testid="order-group-order" [order]="order"></app-order-group-order-item>
    }
  </div>
</div>
